import updateArticleAnalysis from "./updateArticleAnalysis";

const articleAnalysisWebsiteServices = {
  updateArticleAnalysis,
};

export default articleAnalysisWebsiteServices;
